import { render, staticRenderFns } from "./workGoals.vue?vue&type=template&id=79438e63&scoped=true&"
import script from "./workGoals.vue?vue&type=script&lang=js&"
export * from "./workGoals.vue?vue&type=script&lang=js&"
import style0 from "./workGoals.vue?vue&type=style&index=0&id=79438e63&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79438e63",
  null
  
)

export default component.exports